// MaskData (密配列) と 1ch PixelSurface の相互変換。選択範囲の実体は PixelSurface に置く。
import { PixelSurface } from '@/pixels/pixelSurface'
import type { MaskData } from './mask'
import { trimMask } from './mask'

export function maskToSurface(mask: MaskData, id: string): PixelSurface {
  const s = new PixelSurface(id, 1)
  if (mask.rect.w > 0 && mask.rect.h > 0) s.writeRect(mask.rect, mask.data)
  return s
}

/** 表面の内容を MaskData に読み出す。空なら null */
export function surfaceToMask(surface: PixelSurface): MaskData | null {
  const b = surface.contentBounds()
  if (!b) return null
  return trimMask({ rect: b, data: surface.readRect(b) })
}
